import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { PricingSelector } from '../components/PricingSelector';
const comparisonTable = [{
  sit: 'Dolor intenso de más de 6 meses',
  sin: 'Hacés los protocolos base y el avance es lento',
  con: 'El Protocolo Intensivo de 7 días rompe el patrón crónico en una semana'
}, {
  sit: 'Querés llegar más profundo que con las manos',
  sin: 'La liberación manual tiene un límite de profundidad',
  con: '6 técnicas con pelota de tenis y rodillo que llegan a capas que los dedos no alcanzan'
}, {
  sit: 'Las contracturas te vuelven siempre',
  sin: 'Liberás y alivias pero el problema regresa',
  con: 'El sistema de fortalecimiento de 8 semanas resuelve el desequilibrio muscular'
}, {
  sit: 'Viajás frecuentemente o trabajás híbrido',
  sin: 'El kit base es para la oficina o el home office',
  con: 'Protocolos específicos para avión, auto, fin de semana y reuniones largas'
}, {
  sit: 'No sabés si podés trabajar así 10 años más',
  sin: 'Miedo real de que el cuerpo te obligue a parar',
  con: 'El Módulo 3 construye la base muscular que extiende tu bienestar laboral'
}, {
  sit: 'Tensión después de reuniones largas',
  sin: 'No tenés herramienta para intervenir sin llamar la atención',
  con: '5 movimientos imperceptibles que podés hacer en cualquier reunión'
}];
const proFeatures = ['Módulo 1: Protocolo Intensivo 7 Días', 'Módulo 2: Liberación Miofascial Avanzada', 'Módulo 3: Fortalecimiento Anti-Contracturas', 'Módulo 4: Protocolo Para Cualquier Contexto', 'Plan semanal de liberación miofascial completo', 'Progresión de 8 semanas para fortalecimiento', 'Checklist de herramientas básicas para el hogar', 'Guía de movimientos imperceptibles en reuniones'];
function MobileComparisonAccordion() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <div className="md:hidden space-y-2" data-id="element-132">
      {comparisonTable.map((row, i) => {
      const isOpen = openIdx === i;
      return <div key={i} className={`bg-white border rounded-xl overflow-hidden transition-all ${isOpen ? 'border-[#2D9596] shadow-md' : 'border-[#D5DCE5]'}`} data-id="element-133">
            <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-2 p-3 text-left" aria-expanded={isOpen} data-id="element-134">
              <div className="flex-1 min-w-0" data-id="element-135">
                <div className="text-[9px] tracking-[0.2em] text-[#2D9596] font-bold uppercase mb-0.5" data-id="element-136">
                  Tu situación
                </div>
                <div className="text-xs text-[#1A2433] font-medium leading-snug" data-id="element-137">
                  {row.sit}
                </div>
              </div>
              <svg className={`w-4 h-4 text-[#2D9596] shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-138">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-139" />
              </svg>
            </button>
            <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-140">
              <div className="overflow-hidden" data-id="element-141">
                <div className="px-3 pb-3 space-y-2 border-t border-[#D5DCE5] pt-2.5" data-id="element-142">
                  <div className="flex items-start gap-2" data-id="element-143">
                    <span className="text-[#1E3A5F] text-xs mt-0.5 shrink-0" data-id="element-144">
                      ❌
                    </span>
                    <p className="text-[11px] text-[#4A5568] leading-snug" data-id="element-145">
                      <span className="font-bold text-[#1E3A5F]" data-id="element-146">
                        Sin PRO:{' '}
                      </span>
                      {row.sin}
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-147">
                    <span className="text-[#2D9596] text-xs mt-0.5 shrink-0" data-id="element-148">
                      ✓
                    </span>
                    <p className="text-[11px] text-[#1A2433] leading-snug font-medium" data-id="element-149">
                      <span className="font-bold text-[#2D9596]" data-id="element-150">
                        Con PRO:{' '}
                      </span>
                      {row.con}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>;
    })}
    </div>;
}
export function PricingSection() {
  return <section id="pricing" className="py-8 md:py-24 bg-[#F1F4F8]" data-id="element-151">
      <div className="max-w-6xl mx-auto px-4" data-id="element-152">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-6 md:mb-16" data-id="element-153">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 sm:px-4 sm:py-2 rounded-full bg-[#1E3A5F]/10 text-[#1E3A5F] font-bold text-[9px] sm:text-xs uppercase tracking-[0.18em] sm:tracking-[0.2em] mb-4 sm:mb-8 border border-[#1E3A5F]/20" data-id="element-154">
            <span className="w-1.5 h-1.5 rounded-full bg-[#1E3A5F] animate-pulse" data-id="element-155" />
            Precio de lanzamiento — Cierra en:
          </div>

          <CountdownTimer data-id="element-156" />

          <p className="text-xs sm:text-base md:text-lg text-[#4A5568] mt-4 sm:mt-8 mb-3 sm:mb-6 italic" data-id="element-157">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-white border border-[#D5DCE5] rounded-xl p-2.5 sm:p-4 shadow-sm" data-id="element-158">
            <div className="text-[9px] sm:text-xs font-bold text-[#1E3A5F] flex items-center gap-1.5 mb-1.5 sm:mb-2 uppercase tracking-wider" data-id="element-159">
              <span className="w-1.5 h-1.5 rounded-full bg-[#1E3A5F] animate-pulse" data-id="element-160" />
              Cupos — Quedan pocos
            </div>
            <div className="w-full bg-[#E8EDF3] rounded-full h-2 sm:h-3 overflow-hidden mb-1 border border-[#D5DCE5]" data-id="element-161">
              <div className="bg-gradient-to-r from-[#1E3A5F] to-[#2D9596] h-full rounded-full transition-all duration-1000" style={{
              width: '68%'
            }} data-id="element-162" />
            </div>
            <div className="text-[9px] sm:text-xs text-[#2D9596] text-right font-medium" data-id="element-163">
              68% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-2xl sm:text-4xl md:text-6xl text-[#1A2433] text-center mb-5 md:mb-12 leading-tight" data-id="element-164">
          Elegí tu <span className="italic" data-id="element-165">Kit</span>
        </h2>

        {/* Pricing selector */}
        <PricingSelector data-id="element-166" />

        {/* PRO Comparison */}
        <div className="max-w-5xl mx-auto mt-10 md:mt-24" data-id="element-167">
          <h3 className="text-xl sm:text-3xl md:text-5xl text-[#1A2433] text-center mb-5 md:mb-12 leading-tight" data-id="element-168">
            ¿Qué agrega el{' '}
            <span className="italic text-[#1E3A5F]" data-id="element-169">Kit PRO</span>?
          </h3>

          {/* Mobile accordion */}
          <MobileComparisonAccordion data-id="element-170" />

          {/* Desktop table */}
          <div className="hidden md:block bg-white border border-[#D5DCE5] rounded-2xl md:rounded-3xl overflow-hidden mb-8 md:mb-12 shadow-md" data-id="element-171">
            <div className="overflow-x-auto" data-id="element-172">
              <table className="w-full text-left min-w-[600px]" data-id="element-173">
                <thead data-id="element-174">
                  <tr className="bg-[#E8EDF3]" data-id="element-175">
                    <th className="p-3 sm:p-4 md:p-6 text-[#1A2433] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#D5DCE5] w-1/3" data-id="element-176">
                      Tu situación
                    </th>
                    <th className="p-3 sm:p-4 md:p-6 text-[#1E3A5F] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#D5DCE5] w-1/3" data-id="element-177">
                      ❌ Sin PRO
                    </th>
                    <th className="p-3 sm:p-4 md:p-6 text-[#2D9596] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#D5DCE5] w-1/3" data-id="element-178">
                      ✓ Con PRO
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-179">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-[#D5DCE5] hover:bg-[#E8EDF3]/50 transition-colors" data-id="element-180">
                      <td className="p-3 sm:p-4 md:p-6 text-[#1A2433] font-medium text-xs sm:text-sm" data-id="element-181">
                        {row.sit}
                      </td>
                      <td className="p-3 sm:p-4 md:p-6 text-[#4A5568] text-xs sm:text-sm" data-id="element-182">
                        {row.sin}
                      </td>
                      <td className="p-3 sm:p-4 md:p-6 text-[#1E3A5F] font-medium text-xs sm:text-sm" data-id="element-183">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white border border-[#D5DCE5] rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-10 mt-5 md:mt-0" data-id="element-184">
            <h4 className="text-base sm:text-2xl md:text-3xl text-[#1A2433] mb-3 sm:mb-8 text-center" data-id="element-185">
              El <span className="italic" data-id="element-186">Kit PRO</span> incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-2 sm:gap-3 md:gap-4" data-id="element-187">
              {proFeatures.map((f, i) => <div key={i} className="flex items-start gap-2" data-id="element-188">
                  <span className="text-[#2D9596] mt-0.5 shrink-0 text-xs sm:text-base" data-id="element-189">
                    ✓
                  </span>
                  <span className="text-[#4A5568] font-medium text-[11px] sm:text-sm md:text-base leading-snug" data-id="element-190">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}